<template>
    <div class="page-content">

        <div id="careers" class="section grow">
            <div class="overlay opacity-50"></div>
            <lottie-player
                autoplay
                loop
                mode="normal"
                preserveAspectRatio="xMidYMid slice"
                src="https://cdn.sleepjar.com/sleepsounds/images/backgrounds/7x3/animated/simple/json/StarryMountains.json"
                class="bg-lottie-player"
            />
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">

                        <h1 class="title color-white mb-10">Link to Alexa</h1>

                        <p class="lead">Linking to Alexa can only be performed from Sleep Jar for Android and iPhone.</p>
                        <p class="lead mb-5">Install the app and link to Alexa to enjoy:</p>

                        <div class="container mb-10">
                            <div class="row justify-content-around">
                                <div class="col-md-4 mb-5">
                                    <span><i class="fas fa-star mr-2"></i>Cross-platform Premium access</span>
                                </div>
                                <div class="col-md-4 mb-5">
                                    <span><i class="fa fa-sync-alt mr-2"></i>Synchronized listening history (soon)</span>
                                </div>
                                <div class="col-md-4">
                                    <span><i class="fas fa-wifi mr-2"></i>Offline listening (Premium required)</span>
                                </div>
                            </div>
                        </div>

                        <div class="row text-center">
                            <div class="col-md-6 mb-5 mr-auto">
                                <a :href="$root.app_link.android" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-android"></i>Install Sleep Jar for Android</a>
                            </div>
                            <div class="col-md-6 ml-auto">
                                <a :href="$root.app_link.ios" target="_blank" class="btn btn-lg btn-light"><i class="fab mr-2 fa-apple"></i>Install Sleep Jar for iPhone</a>
                            </div>
                        </div>

                         <p class="lead mt-5"><small class="opacity-50">Geographic restrictions may apply. Check the Android or iOS app store for app availability in your country.</small></p>

                        

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data () {
        return {
        };
    },
    name: 'alexa-link',
    metaInfo: {
        title: 'Link to Alexa',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'Link your Sleep Jar account to Amazon Alexa for the best cross-platform experience.'
            }
        ]
    },
    methods: {
    },
    computed: {
    },
    components: {
    },
    mounted(){
    }
}
</script>
